import React from 'react';
import { useConfiguration } from '../configuration/use-configuration';
import { st, classes } from './card.st.css';

export const Card: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isCardShadowEnabled } = useConfiguration();
  return <li className={st(classes.root, { withShadow: isCardShadowEnabled })}>{children}</li>;
};
